import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["loading"]

    connect() {
        // Add change event listeners to all form elements
        this.element.querySelectorAll("input, select, textarea").forEach(element => {
            element.addEventListener("change", this.submit.bind(this))
        })

        // Listen for turbo events to manage loading state
        this.element.addEventListener("turbo:submit-start", this.showLoading.bind(this))
        this.element.addEventListener("turbo:submit-end", this.hideLoading.bind(this))
        this.element.addEventListener("turbo:frame-load", this.hideLoading.bind(this))
    }

    submit(event) {
        // Use requestSubmit instead of submit to trigger form validation and Turbo's handling
        this.element.requestSubmit()
    }

    showLoading() {
        // Show loading indicator
        if (this.hasLoadingTarget) {
            this.loadingTarget.classList.remove("hidden")
        }

        // Disable form elements to prevent multiple submissions
        this.element.querySelectorAll("input, select, textarea, button").forEach(element => {
            element.disabled = true
        })

        // Add loading class to form for styling
        this.element.classList.add("loading")
    }

    hideLoading() {
        // Hide loading indicator
        if (this.hasLoadingTarget) {
            this.loadingTarget.classList.add("hidden")
        }

        // Re-enable form elements
        this.element.querySelectorAll("input, select, textarea, button").forEach(element => {
            element.disabled = false
        })

        // Remove loading class from form
        this.element.classList.remove("loading")
    }
}
